<script>
	import { createEventDispatcher } from 'svelte';

    const dispatch = createEventDispatcher();

    export let allLines;

    let selectedLines = {};
    
    function done() {
        let selected = Object.keys(selectedLines).filter(k => selectedLines[k]);
        if (selected.length == 0) {
            selected = allLines;
        }
        dispatch('done', {
            selectedLines: selected
        });
    }
</script>

<style>
.container {
    max-height: 100%;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
}
.linesContainer {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
    overflow: scroll;
}
.linesContainer::after {
  content: "";
  flex: auto;
}
.lineCheckbox {
    width: 4em;
    margin: 5px;
}
.lineCheckboxLabel {
    display: block;
    border: 1px solid rgb(210, 210, 210);
    border-radius: 7px;
    padding-top: 1em;
    padding-bottom: 0.9em;
}
.doneButton {
    width: 100%;
    background: white;
    box-sizing: border-box;
    padding: 1em;
}
.doneButton > button {
    width: 100%;
    height: 3em;
}
</style>

<div class="container">
    <div class="linesContainer">
        {#each allLines as line}
        <div class="lineCheckbox">
            <label class="lineCheckboxLabel">
                <input type="checkbox" id={line} bind:checked={selectedLines[line]}>
                <span>{line}</span>
            </label>
        </div>
        {/each}
    </div>
    <div class="doneButton"><button on:click={done}>OK</button></div>
</div>